import * as React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';


function preventDefault(event) {
  event.preventDefault();
}

export default function Deposits() {
  return (
    <React.Fragment>
       <Typography component="h2" variant="h6" color="primary" gutterBottom>
       Current School Budget 
    </Typography>
      <Typography component="p" variant="h4" display='flex'>
        $3,024.00
      </Typography>
      <Typography color="text.secondary" sx={{ flex: 1 }}>
        1st October - 31st December 2022
      </Typography>
      <div>
      </div>
    </React.Fragment>
  );
}